// billing.lang.es.js
const billingES = {
	title: "Facturación y Suscripción",
	loading: "Cargando...",
	errorLoading: "No se pudieron cargar los detalles de facturación en este momento.",

	currentSubscription: "Suscripción Actual",
	noSubscription: "No se encontró una suscripción.",
	startSubscription: "Comenzar suscripción",

	pricePerInterval: "{currency} {amount} / {interval}",
	nextBillingOn: "Próximo cobro: {date}",
	status: "Estado",
	billingInterval: "Cada {frequency} {interval}(s)",

	buttons: {
		updatePaymentMethod: "Actualizar método de pago",
		cancelSubscription: "Cancelar suscripción",
		manageSubscription: "Administrar suscripción",
	},

	paymentMethod: {
		title: "Método de Pago",
		noStored: "No hay método de pago guardado.",
		brand: "Marca",
		last4: "Últimos 4",
		expires: "Vence",
	},

	billingInfo: {
		title: "Información de Facturación",
		started: "Inició",
		firstBilled: "Primer cobro",
		nextBilling: "Próximo cobro",
		interval: "Intervalo",
	},

	plans: {
		title: "Planes Disponibles",
		options: "{count} opciones",
		choosePlan: "Elegir plan",
	},

	seats: {
		activeSeats: "{count} asiento(s) activo(s)",
		seatPricing: "{currency} {amount} por asiento / mes",
		total: "Total facturado: {currency} {total}",
	},

	statusBadge: {
		active: "Activa",
		canceled: "Cancelada",
		paused: "Pausada",
		trialing: "En prueba",
		pastDue: "Vencida",
	},

	referral: {
		title: "Programa de Referidos",
		loading: "Cargando...",
		noCode: "Aún no tienes un código de referido.",
		generate: "Generar código de referido",

		codeLabel: "Tu código:",
		copyCode: "Copiar código",
		copied: "Copiado al portapapeles",

		historyTitle: "Historial de Referidos",
		noReferrals: "Aún no hay referidos.",
		defaultShopName: "Nuevo negocio",

		status: {
			pending: "Pendiente",
			active: "Activo",
			converted: "Convertido",
		},
	},

	misc: {
		month: "mes",
	},
};

export default billingES;
